import React from 'react';
import './index.scss';

import browers_icon from '../../assets/browsers.png';
import qrcode_icon from '../../assets/qrcode.png';

export class RecruitmentPage extends React.Component {
  render() {
    return (
      <div className="recruitment-page">
        <section className="header">
          <h1>智联招聘 X iSlide专属福利</h1>
        </section>
        <section className="section">
          <div className="section-title">
            <h3>福利 ➀</h3>
            <p>免费获得iSlide会员</p>
          </div>
          <div className="section-body body-1">
            <div className="section-form">
              <h4>获取海量职场PPT模版</h4>
              <input type="text" placeholder="您的邮箱地址" />
              <button>开通VIP账号</button>
            </div>
            <img src={browers_icon} />
          </div>
        </section>
        <section className="section">
          <div className="section-title">
            <h3>福利 ➁</h3>
            <p>额外获取10G PPT作品/教程大礼包</p>
          </div>
          <div className="section-body body-2">
            <div className="section-qrcode-container">
              <div className="section-qrcode">
                <h3>PPT10G素材大礼包获取</h3>
                <p>按识别二维码回复 礼包 即可</p>
                <hr />
                <img src={qrcode_icon} />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
